module.exports = __webpack_public_path__ + "img/icon-wallet.bfa6147c.svg";